module.exports = __webpack_public_path__ + "img/lgpr_cover_image.3559e458.jpg";